import _extends from "@babel/runtime/helpers/extends";
import OriginTypography from './Typography';
import Text from './Text';
import Link from './Link';
import Title from './Title';
import Paragraph from './Paragraph';
import * as VarnishAdditions from './varnish'; // Added by Varnish

var Typography = OriginTypography;
Typography.Text = Text;
Typography.Link = Link;
Typography.Title = Title;
Typography.Paragraph = Paragraph;

_extends(Typography, VarnishAdditions); // Added by Varnish


export default Typography;